import { Accordion, AccordionItem, AccordionPanel, AccordionTrigger } from '@wundo/ui';
import type { ConversationDebugPayload } from '@/lib/conversationDebug.ts';
import { DebugRow, DebugSection } from './DebugSection.tsx';

/** What the orchestrator was doing: the skill it ran, where it came from, its context. */
export function OrchestratorSection({ data }: { data: ConversationDebugPayload }) {
  return (
    <DebugSection title='Orchestrator'>
      <dl>
        <DebugRow label='Active skill'>
          {data.active_skill?.title ?? data.conversation.active_skill_id ?? '—'}
        </DebugRow>
        <DebugRow label='Origin recommendation'>
          {data.conversation.origin_recommendation_id ?? '—'}
        </DebugRow>
        <DebugRow label='Origin schedule'>
          {data.conversation.origin_schedule_id ?? '—'}
        </DebugRow>
      </dl>
      {data.conversation.agent_context && (
        <Accordion>
          <AccordionItem>
            <AccordionTrigger className='px-3.5 py-2.5 text-sm'>
              Agent context
            </AccordionTrigger>
            <AccordionPanel className='px-3.5 pb-3'>
              <pre className='overflow-x-auto rounded-sm bg-fill-faint p-2 text-xs whitespace-pre-wrap text-ink-body'>
                {JSON.stringify(data.conversation.agent_context, null, 2)}
              </pre>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
    </DebugSection>
  );
}
